import { InputLabel, styled } from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';

export const HintStyles = styled(InputLabel)`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  padding-bottom: 0px;
  font-size: ${pxToRem('8px')};
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 16px;
  color: #758ba3;
  text-transform: uppercase;

  .hint__label {
    vertical-align: super;
  }

  .hint__error {
    color: #c33000;
  }

  .tooltip {
    width: 16px;
    height: 16px;
    margin-left: 8px;
    cursor: pointer;
  }
`;
